// extracted by mini-css-extract-plugin
module.exports = {"container":"IntegrationDetails_container__1c6W8"};